import { render, staticRenderFns } from "./CustomTimetableWeekCustom.vue?vue&type=template&id=deda1594&scoped=true&"
import script from "./CustomTimetableWeekCustom.vue?vue&type=script&lang=js&"
export * from "./CustomTimetableWeekCustom.vue?vue&type=script&lang=js&"
import style0 from "./CustomTimetableWeekCustom.vue?vue&type=style&index=0&id=deda1594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deda1594",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCalendar,VContainer,VDatePicker,VIcon,VMenu,VSheet,VSkeletonLoader,VSpacer,VSwitch,VToolbar,VToolbarItems})
